module.exports = __webpack_public_path__ + "static/media/EnrollmentGetStarted.6d53bf48.jpg";